import React from 'react'
import { Link } from 'react-router-dom'
import { Button, usePermissions } from 'react-admin'
import EventIcon from '@mui/icons-material/Event'

const CreateIspectionButton = ({ leadProperty }) => {
  const { permissions } = usePermissions()

  if (permissions?.inspection.canCreate) {
    return (
      <Button
        component={Link}
        to={{
          pathname: `/visits/create`,
          search: `?for=${leadProperty.id}`,
        }}
        label="Create inspection"
        color="primary"
      >
        <EventIcon />
      </Button>
    )
  } else {
    return null
  }
}

export default CreateIspectionButton
